var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adurl"},[_c('div',{staticClass:"title"},[_c('van-nav-bar',{attrs:{"title":"荷叶健康","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1),_c('iframe',{attrs:{"src":_vm.$route.query.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }